'use client';

import CardsContainer from '../../../../components/common/cards/CardsContainer';
import Card from '../../../../components/common/cards/Card/Card';
import { INewsItemEntry } from '../../../../contentful/types/INewsItemEntry';
import { getCardImageSource } from '../../../../utils/getCardImageSource';
import { PageRoutes } from '../../../app/pages/domain/constants/PageRoutes';

interface INewsSectionHomeCards {
	newsItems: INewsItemEntry[];
}

export default function NewsSectionHomeCards({
	newsItems,
}: INewsSectionHomeCards) {
	return (
		<CardsContainer>
			{newsItems.map((item: INewsItemEntry) => (
				<Card
					key={item.id}
					type="news"
					title={item.fields.title}
					body={item.fields.summary || item.fields.body}
					imageSource={getCardImageSource(item.fields.image)}
					linkHref={`${PageRoutes.CorporateNewsroomNewsItem}/${item.fields.slug}`}
					publicationDate={item.fields.publicationDate}
					imageAlt={item.fields.image?.fields.title || ''}
					categories={item.fields.categories}
				/>
			))}
		</CardsContainer>
	);
}
